import { render, staticRenderFns } from "./_base-filter-button.vue?vue&type=template&id=b5e673de"
import script from "./_base-filter-button.vue?vue&type=script&lang=js"
export * from "./_base-filter-button.vue?vue&type=script&lang=js"
import style0 from "./_base-filter-button.vue?vue&type=style&index=0&id=b5e673de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@6.11.0_webpack@5.105.4__ejs@3.1._edcc41725b38a2c96ace736fbd249f4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports